<footer class="loyalty-tabbar">
   <div class="w-100 d-flex jc-evenly ai-center p-x-16">
      <a class="tab-item" [class.active]="active === 'inicio'" routerLink="/inicio">
         <i-tabler name="home" class="icon-22 stroke-1" />
         <p class="f-s-11 f-w-600">{{ 'Home' | i18n }}</p>
      </a>
      <a class="tab-item" [class.active]="active === 'beneficios'" routerLink="/beneficios">
         <i-tabler name="gift" class="icon-22 stroke-1" />
         <p class="f-s-11 f-w-600">{{ 'Benefits' | i18n }}</p>
      </a>
      <a class="tab-item" [class.active]="active === 'resgates'" routerLink="/resgates">
         <i-tabler name="receipt" class="icon-22 stroke-1" />
         <p class="f-s-11 f-w-600">{{ 'Redemptions' | i18n }}</p>
      </a>
      <a class="tab-item" [class.active]="active === 'perfil'" routerLink="/perfil">
         <i-tabler name="user" class="icon-22 stroke-1" />
         <p class="f-s-11 f-w-600">{{ 'Profile' | i18n }}</p>
      </a>
   </div>
</footer>
